import { Button as MuiButton, ButtonProps as MuiButtonProps, styled } from '@mui/material';


const StyledCardButton = styled(MuiButton)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: 0,
  height: 'auto',
}));

export default function CardButton<C extends React.ElementType>(props: MuiButtonProps<C, { component?: C }>) {
  return <StyledCardButton
    size="large"
    {...props}
  />
}